import { isMain } from '@/utils/tools'
// -------------------------------------------------------------
// 生涯学院表单页面
let careerCollege = () => import( /* webpackChunkName: "group-index" */ '@/views/career_college/form');

export default [
    {
        path: '/career_college',
        name: '加载中',
        component: careerCollege
    }
]